import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'loyaltic-feedback-success',
  templateUrl: './feedback-success.component.html',
  styleUrls: ['./feedback-success.component.scss']
})
export class FeedbackSuccessComponent implements OnInit {

  status: string;

  constructor(
    private route: ActivatedRoute,
    private router:  Router
  ) { }

  ngOnInit() {
    this.status = this.route.snapshot.queryParamMap.get('status');
  }

}
